import { useTheme } from '@mui/material';
import { brandColors } from '../../theme';
import { styleConstants } from '../../Utils/styleConsts';
export const useStyles = () => {
    const theme = useTheme();
    return {
        title: {
            color: theme.palette.primary.dark,
            paddingBottom: '0.25rem',
            [theme.breakpoints.down('xs')]: {
                fontSize: '1.5rem',
            },
        },
        tableWrapper: {
            backgroundColor: theme.palette.background.paper,
            overflow: 'auto',
            maxWidth: '100%',
        },
        mobileRow: {
            backgroundColor: theme.palette.background.paper,
            display: 'flex',
            border: `1px solid ${brandColors.tableBorder}`,
            borderRadius: theme.shape.borderRadius,
            justifyContent: 'space-between',
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
        mobileList: {
            listStyleType: 'none',
            padding: 0,
            margin: 0,
            width: '100%',
            '& > li': {
                display: 'flex',
                '&:nth-of-type(even)': {
                    backgroundColor: theme.palette.grey[100],
                },
            },
        },
        header: {
            fontWeight: 900,
            width: '50%',
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            paddingLeft: theme.spacing(1),
        },
        value: {
            width: '50%',
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
        receipt: {
            margin: theme.spacing(1),
            display: 'flex',
            justifyContent: 'flex-end',
        },
        button: {
            textTransform: styleConstants.buttonTextTransform,
            fontSize: styleConstants.buttonFontSize,
            fontWeight: styleConstants.buttonFontWeight,
            padding: styleConstants.buttonPadding,
        },
    };
};
